import script from "./CallBriefcaseDropdownItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CallBriefcaseDropdownItem.vue?vue&type=script&setup=true&lang=js"

import "./CallBriefcaseDropdownItem.vue?vue&type=style&index=0&id=0b718906&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b718906"]])

export default __exports__